export default __webpack_public_path__ + "static/media/nanny.c4b9495e.svg";